<template>
  <vs-col class="reset-alert-height" v-if="Boolean(selected)">
    <vs-alert
      :active="Boolean(selected)"
      :title="selected.NOMECOMERCIAL"
      color="dark"
    >
      <p style="margin-top:-10px;">
        Atendimento (protocolo): <strong>{{ attendance }}</strong>
      </p>
    </vs-alert>
  </vs-col>
</template>

<script>
import { getStepsInformation } from "../helpers/storage";

export default {
  name: "SelectedCourseBox",
  data: () => ({
    selected: null,
    attendance: null,
  }),
  created() {
    const stepsData = getStepsInformation();
    if (stepsData.course) this.selected = stepsData.course;
    if (stepsData.codAtendimento) this.attendance = stepsData.codAtendimento;
  },
};
</script>

<style>
.reset-alert-height > div {
  height: initial !important;
}
</style>
